// extracted by mini-css-extract-plugin
export default {"container":"mic_3Ditn","summary":"mic_sum_17BAz","summaryTitle":"mic_sum_kXoEy","summaryButton":"mic_sum_1VW41","label":"mic_lab_3v-iI","imageContainer":"mic_ima_2F5w5"};